import { Get, Put, Post, Delete, Patch } from "./api.helper";
import { store } from "../store";
import { handleFetchError } from "../utils/errorHandler";
import Config from "../Config";

// ==== Authentication
export const Login = (bodyData) => {
    return Post({
        url: "/auth/login",
        body: bodyData,
        isAuthorized: false
    });
};

export const GetMe = () => {
    return Get({ url: "/user/me" });
};

export const ForgotPassword = (bodyData) => {
    return Post({ url: "/auth/forget-password", body: bodyData });
};

export const ForgotPasswordVerification = (bodyData) => {
    return Post({
        url: "/auth/forget-password/verification",
        body: bodyData
    });
};

export const ResetPassword = (bodyData) => {
    return Post({ url: "/auth/reset-password", body: bodyData });
};

export const VerifyUser = (bodyData) => {
    return Post({
        url: "/",
        body: bodyData,
        isAuthorized: false
    });
};

export const SignUp = (bodyData) => {
    return Post({
        url: "/auth/signup",
        body: bodyData,
        isAuthorized: false
    });
};

//Dashboard

export const GetAnalytics = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/dashboard/analytics", params, abortSignal });
};

export const GetVisuals = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/dashboard/visuals", params, abortSignal });
};

//users
export const UpdateUserById = (bodyData) => {
    return Patch({ url: `/user`, body: bodyData });
};

export const DeleteUserById = ({ Id }) => {
    return Delete({ url: `/user/${Id}/delete-account` });
};

export const ChangePasswordAccount = (bodyData) => {
    return Post({ url: `/auth/change-password`, body: bodyData });
};

//Audio Management

export const GetAudios = ({ params = {}, abortSignal = null }) => {
    return Get({
        url: "/albums",
        params,
        abortSignal
    });
};

// Get Audio Sub Category
export const GetAudiosSubCategories = ({ params = {}, abortSignal = null }) => {
    return Get({
        url: "/labels",
        params,
        abortSignal
    });
};

// Get Author
export const GetAuthor = ({ params = {}, abortSignal = null }) => {
    return Get({
        url: "/authors",
        params,
        abortSignal
    });
};

// Get Author
export const GetNarrator = ({ params = {}, abortSignal = null }) => {
    return Get({
        url: "/narrators",
        params,
        abortSignal
    });
};

//AUDIO MANAGEMENT

export const UpdateAudioStatusById = ({ Id, bodyData }) => {
    return Patch({ url: `/album/status/${Id}`, body: bodyData });
};

export const CreateAlbum = (bodyData) => {
    return Post({
        url: "/album",
        body: bodyData
    });
};

export const UpdateAlbum = (bodyData, id) => {
    return Put({
        url: `/album/${id}`,
        body: bodyData
    });
};

export const DeleteAlbum = (id) => {
    return Delete({
        url: `/album/${id}`
    });
};

export const GetSingleAudioListing = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/albums", params, abortSignal });
};
export const GetGoalListing = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/goals", params, abortSignal });
};

export const CreateGoal = (bodyData) => {
    return Post({
        url: "/goal",
        body: bodyData
    });
};
export const UpdateGoal = (id, bodyData) => {
    return Patch({
        url: `/goal/${id}`,
        body: bodyData
    });
};

export const DeleteGoalById = (id) => {
    return Delete({ url: `/goal/${id}` });
};

//Get Audio By Id
export const GetAudioById = ({ Id }) => {
    return Get({ url: `/album/${Id}` });
};
export const GetGoalById = ({ id }) => {
    return Get({ url: `/goal/${id}` });
};

//User Management
export const GetUsers = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/users", params, abortSignal });
};

export const GetUsersById = ({ Id }) => {
    return Get({ url: `/user/${Id}` });
};

//Notification Management

export const CreateNotification = (bodyData) => {
    return Post({
        url: "/app-notification",
        body: bodyData
    });
};

export const GetNotification = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/app-notifications", params, abortSignal });
};

export const GetNotificationById = ({ Id }) => {
    return Get({ url: `/app-notification/${Id}` });
};

export const UpdateNotificationById = (Id, bodyData) => {
    return Patch({ url: `/app-notification/${Id}`, body: bodyData });
};

export const GetAgeBracket = ({ params = {}, abortSignal = null }) => {
    return Get({
        url: "/age-bracket",
        params,
        abortSignal
    });
};

export const DeleteNotification = (id) => {
    return Delete({
        url: `/app-notification/${id}`
    });
};

export const MediaUpload = (bodyData, abortSignal = null) => {
    const token = store.getState().userAuth.user.Token;

    const url = `${Config.env().API_URL}/media/upload`;

    return fetch(url, {
        headers: {
            authorization: token
        },
        body: bodyData,
        method: "POST"
    }).then(handleFetchError);
};

// @Narrator APIs

export const GetNarratorListing = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/narrators", params, abortSignal });
};

export const DeleteNarratorById = (id) => {
    return Delete({ url: `/narrator/${id}` });
};

export const GetNarratorById = ({ id }) => {
    return Get({ url: `/narrator/${id}` });
};

export const CreateNarrator = (bodyData) => {
    return Post({
        url: "/narrator",
        body: bodyData
    });
};

export const UpdateNarrator = (id, bodyData) => {
    return Patch({
        url: `/narrator/${id}`,
        body: bodyData
    });
};
// @Author APIs

export const GetAuthorListing = ({ params = {}, abortSignal = null }) => {
    return Get({ url: "/authors", params, abortSignal });
};

export const DeleteAuthorById = (id) => {
    return Delete({ url: `/author/${id}` });
};

export const GetAuthorById = ({ id }) => {
    return Get({ url: `/author/${id}` });
};
export const CreateAuthor = (bodyData) => {
    return Post({
        url: "/author",
        body: bodyData
    });
};

export const UpdateAuthor = (id, bodyData) => {
    return Patch({
        url: `/author/${id}`,
        body: bodyData
    });
};

export const UpdateUserStatusById = ({ Id, bodyData }) => {
    return Patch({ url: `/user/status/${Id}`, body: bodyData });
};
